import { Dispatch, FC, memo, SetStateAction, useState } from 'react'
import { Box } from '@chakra-ui/react'

import FilterGroupHeader from '../FilterGroupHeader'
import FilterTexts from './components/FilterTexts'
import FilterInput from './components/FilterInput'

type CustomSelectProps = {
  options?: any
  optionLabelKey?: string
  optionValueKey?: string
  formatValue?: (inputValue: string) => string
}

export type FilterGroupInputsProps = CustomSelectProps & {
  type: string
  id?: string
  label: string
  name: string
  autoFocus?: boolean
  mask?: (value: string) => string
}

type CitizenFilterWithKey = any & {
  [key: string]: string
}

type Props = {
  title: string
  description: string
  fields: FilterGroupInputsProps[]
  values: CitizenFilterWithKey
  setValues: Dispatch<SetStateAction<any>>
  shouldOpen?: boolean
  onSubmitFilters?: () => void
}

const FilterGroupForInputs: FC<Props> = ({ title, description, shouldOpen = false, fields, values, setValues }) => {
  const [openAccordion] = useState(shouldOpen)

  // function onSubmitButton() {
  //   setOpenAccordion(false)
  //   onSubmitFilters()
  // }

  return (
    <FilterGroupHeader
      title={title}
      description={description}
      shouldOpen={openAccordion}
      contentWhenAccordionIsClose={<FilterTexts fields={fields} values={values} />}
      content={
        <Box>
          {fields.map((field, index) => (
            <FilterInput key={field.name} field={field} index={index} values={values} setValues={setValues} />
          ))}
          {/* 
          <Button mt={2} onClick={onSubmitButton} minWidth="100%">
            Buscar
          </Button> */}
        </Box>
      }
    />
  )
}

export default memo(FilterGroupForInputs)
